if (!customElements.get('yl-welcome-popup')) {
  customElements.define('yl-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.current = 0;
      this.storageKey = 'yl-welcome-popup-release-20261022-3';
      this.returnFocus = null;
      this.onPageHide = () => this.stop();
      this.onVisibility = () => document.hidden ? this.stop() : this.start();
      this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => { this.stop(); this.remember(); this.returnFocus?.focus({preventScroll:true}); });
      this.querySelector('[data-copy-code]')?.addEventListener('click', async () => {
        const message = this.querySelector('[data-copy-status]');
        try { await navigator.clipboard.writeText(this.dataset.code); message.textContent = this.dataset.copied; }
        catch { message.textContent = this.dataset.copyError; }
      });
      this.form?.addEventListener('submit', () => { if (this.form.reportValidity()) { this.form.setAttribute('aria-busy','true'); this.dialog.close(); } });
      this.querySelectorAll('.ad-area a').forEach(link => link.addEventListener('click', () => this.remember()));
      document.addEventListener('visibilitychange',this.onVisibility);
      window.addEventListener('pagehide',this.onPageHide);
      const status = this.querySelector('[data-form-state]')?.dataset.formState;
      let seen = false;
      try { seen = Boolean(localStorage.getItem(this.storageKey) || sessionStorage.getItem(this.storageKey)); } catch {}
      const editor = this.dataset.designMode === 'true';
      if (status === 'success' || status === 'error' || editor || (this.dataset.existingCustomer !== 'true' && !seen)) {
        this.openTimer = setTimeout(() => this.open(), status || editor ? 0 : 1000);
      }
    }
    remember() {
      if (this.dataset.designMode === 'true') return;
      try { localStorage.setItem(this.storageKey, 'seen'); } catch {}
      try { sessionStorage.setItem(this.storageKey, 'seen'); } catch {}
    }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      if (document.querySelector('dialog[open]')) { this.openTimer = setTimeout(() => this.open(),1000); return; }
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.dialog.focus({preventScroll:true});
      this.remember();
      this.start();
    }
    start() {
      this.stop();
      if (!this.dialog.open || document.hidden || this.slides.length < 2) return;
      this.timer = setInterval(() => {
        this.current = (this.current + 1) % this.slides.length;
        this.slides.forEach((slide,index) => { slide.hidden = index !== this.current; });
      },2000);
    }
    stop() { clearInterval(this.timer); }
    disconnectedCallback() {
      this.stop(); clearTimeout(this.openTimer);
      document.removeEventListener('visibilitychange',this.onVisibility);
      window.removeEventListener('pagehide',this.onPageHide);
    }
  });
}
